import api from './axios'; 

const tagsRequests = {
    getAllTags(){
        return api.get('/tags', { orgContext: 'tenant' })
    },
    saveTag(form){
        return api.post('/tags',form, { orgContext: 'tenant' })
    },
    updateTag(id,form){
        return api.patch(`/tags/${id}`,form, { orgContext: 'tenant' })
    },
    deleteTag(id){
        return api.delete(`/tags/${id}`, { orgContext: 'tenant' })
    }
};

export default tagsRequests;
